export default __webpack_public_path__ + "static/media/AITT.701b55d1.jpg";